


















import { Component, Vue } from "vue-property-decorator";
import { BaseModule } from "@/store/base.module";

@Component({
  name: "AppProgress",
})
export default class extends Vue {
  get isLoading() {
    return BaseModule.isLoading;
  }
}
